export const humanizeReason = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
